/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Step_3_TitleInputs */

const da_forside_step_3_title = /** @type {(inputs: Forside_Step_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gennemgå og godkend`)
};

/** @type {(inputs: Forside_Step_3_TitleInputs) => LocalizedString} */
const en_forside_step_3_title = da_forside_step_3_title;

/**

* @param {Forside_Step_3_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_step_3_title = /** @type {((inputs?: Forside_Step_3_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Step_3_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_step_3_title(inputs)
	return /** @type {LocalizedString} */ ("Gennemgå og godkend")
});